export default __webpack_public_path__ + "static/media/gif4_slow.719b7d72.gif";